import './less/mc-styles.less';
import 'Styles';

import "JQueryScripts/common-script-pack";
